export default __webpack_public_path__ + "static/team-medellin-340c390eab435a465c2dd790e0d7a022.jpg";